import React, { useState, useEffect } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { addCommas } from './../../addComas'
import { sortData } from './../../addComas'
import { db } from './../../Firebase'
import CircularProgress from '@material-ui/core/CircularProgress';


export default function Balanza() {
    const [Data, setData] = useState(null)

    //Get DATA from firebase
    useEffect(() => {
        db.collection('Pruebas').doc('EXP')
            .collection('BALANZA').doc('data')
            .onSnapshot(snapshot => {
                setData(sortData(snapshot.data()))
            });
    }, [])

    return (
        <div className='inv-table-container'>
            <div style={{ width: '100%', height: '100%' }}>
                <h3 >
                    Balanza comercial {Data && Data['Fecha']}
                    <br />
                    (USD Millones FOB)
                    </h3>
                {Data ? (

                    <TableContainer component={Paper} >
                        <Table aria-label="simple table">

                            <TableBody>

                                <TableRow key={'Exportaciones'} >

                                    <TableCell component="th" scope="row">
                                        Exportaciones
                                        </TableCell>
                                    <TableCell align="right">{addCommas(Data['Exportaciones'])}</TableCell>
                                </TableRow>

                                <TableRow key={'Importaciones'} >
                                    <TableCell component="th" scope="row">
                                        Importaciones
                                        </TableCell>
                                    <TableCell align="right">{addCommas(Data['Importaciones'])}</TableCell>
                                </TableRow>

                                <TableRow key={'Balanza'} >
                                    <TableCell component="th" scope="row">
                                        Balanza comercial
                                        </TableCell>
                                    <TableCell align="right">{addCommas(Data['Balanza Comercial'])}</TableCell>
                                </TableRow>

                            </TableBody>
                        </Table>
                    </TableContainer>
                ) : (
                        <CircularProgress color="secondary"></CircularProgress>
                    )}
            </div>
        </div>
    );
}
